module.exports = __webpack_public_path__ + "static/media/coin-logo.85c9408d.svg";